'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import { useNavigate } from 'react-router-dom'
import { useOpportunityStore } from '@store/Opportunity'
import Pressable from '@components/kit/pressable'
import Loading from '@components/kit/loading'

/* -----------------------------------------------------------------------------
 * Custom Opportunity
 * -------------------------------------------------------------------------- */

export function CustomOpportunity() {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)

  const categories = useOpportunityStore(state => state.categories)
  const { fetchOpportunityCategories } = useOpportunityStore.getState()

  useEffect(() => {
    if (isLoading) {
      fetchOpportunityCategories().then(() => {
        setIsLoading(false)
      })
    }
  }, [isLoading, fetchOpportunityCategories])
  return (
    <Box mt='16'>
      {(categories ?? []).map((category, index) => (
        <Box key={index} mb='16' gap='08'>
          <Pressable
            onPress={() => navigate(`/opportunities/category/${category.id}`)}
          >
            <Text font='text.14.medium' textColor='walrusBlue200'>
              {category.title}
            </Text>
          </Pressable>
        </Box>
      ))}
      {isLoading && <Loading size='large' />}
    </Box>
  )
}
